/**
 * 管理员相关 API
 */

import { request } from '@umijs/max';
import type {
  ApiResponse,
  LoginRequest,
  LoginResponse,
  CaptchaResponse,
  Admin,
  ChangePasswordRequest,
  UpdateAdminRequest,
} from './types';

/**
 * 获取验证码
 */
export async function getCaptcha() {
  return request<ApiResponse<CaptchaResponse>>('/admin/auth/captcha', {
    method: 'GET',
  });
}

/**
 * 管理员登录
 */
export async function login(data: LoginRequest) {
  return request<ApiResponse<LoginResponse>>('/admin/auth/login', {
    method: 'POST',
    data,
  });
}

/**
 * 获取当前管理员信息
 */
export async function getCurrentAdmin(options?: { [key: string]: any }) {
  return request<ApiResponse<Admin>>('/admin/me', {
    method: 'GET',
    ...(options || {}),
  });
}

/**
 * 刷新 Token
 */
export async function refreshToken() {
  return request<ApiResponse<LoginResponse>>('/admin/auth/refresh', {
    method: 'POST',
    data: {},
  });
}

/**
 * 修改密码
 */
export async function changePassword(data: ChangePasswordRequest) {
  return request<ApiResponse<void>>('/admin/auth/password', {
    method: 'PUT',
    data,
  });
}

/**
 * 修改管理员信息
 */
export async function updateAdminInfo(data: UpdateAdminRequest) {
  return request<ApiResponse<void>>('/admin/auth/info', {
    method: 'PUT',
    data,
  });
}
